// Employee (Management → Employees) request schemas — the worker validates, the SPA reuses the same
// shapes so the form and the server never drift. Name is the one required field; everything else is
// optional/defaulted so a partial record still saves.
import { z } from 'zod';
import { EMPLOYEE_TEAMS } from '../domain/employee.js';
const s = (max) => z.string().max(max).optional().default('');
export const EmployeeFieldsSchema = z.object({
    name: z.string().trim().min(1, 'Name is required').max(160),
    employeeNo: s(40),
    // only the known assembly-floor teams are stored — anything else (incl. a comma-containing value that
    // would break the comma-joined column encoding) is dropped, so the round-trip is always safe.
    teams: z.array(z.string().max(40)).max(20).optional().default([])
        .transform((a) => a.filter((t) => EMPLOYEE_TEAMS.includes(t))),
    department: s(80),
    jobTitle: s(120),
    startDate: s(20), // 'YYYY-MM-DD' or ''
    phone: s(60),
    email: z.string().max(200).optional().default(''),
    active: z.boolean().optional().default(true),
});
export const EmployeeCreateSchema = EmployeeFieldsSchema;
export const EmployeeUpdateSchema = EmployeeFieldsSchema.extend({
    id: z.number().int().positive(),
});
export const EmployeeIdSchema = z.object({ id: z.number().int().positive() });
//# sourceMappingURL=employees.js.map